import {createFileRoute} from '@tanstack/react-router';
import {InvoiceAccountCloseInfoPage} from '../../../../../../features/one-time-credit/pages/InvoiceAccountClosePage/InvoiceAccountCloseInfoPage';

export const Route = createFileRoute(
  '/_protected/accounts/invoices/$accountId/close/',
)({
  component: InvoiceAccountCloseInfoPage,
});
